import {LicenseStatus} from '@/types';
import type {StatusIntent} from './StatusChip';

/** Keeps the previous licence status chip rules in one place. */
export function licenseStatusChipProps(status: string): {
    intent: StatusIntent;
    variant: 'filled' | 'outlined';
} {
    const variant =
        status === LicenseStatus.PENDING ? 'filled' : 'outlined';
    let intent: StatusIntent;
    if (status === LicenseStatus.APPROVED) {
        intent = 'success';
    } else if (status === LicenseStatus.REJECTED) {
        intent = 'error';
    } else if (status === LicenseStatus.EXPIRED) {
        intent = 'neutral';
    } else {
        intent = 'warning';
    }
    return {intent, variant};
}
